if (!customElements.get('bts-product-showcase')) {
  customElements.define(
    'bts-product-showcase',
    class BTSProductShowcase extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-bts-showcase-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-bts-showcase-panel]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab.dataset.btsShowcaseTab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
        });
      }

      selectTab(panelId, moveFocus = false) {
        this.tabs.forEach((tab) => {
          const isSelected = tab.dataset.btsShowcaseTab === panelId;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
          if (isSelected && moveFocus) tab.focus();
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });
      }

      onKeydown(event, currentTab) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.selectTab(this.tabs[nextIndex].dataset.btsShowcaseTab, true);
      }
    }
  );
}

document.addEventListener('shopify:block:select', (event) => {
  const section = event.target.closest('bts-product-showcase');
  const panel = event.target.closest('[data-bts-showcase-panel]');
  if (section && panel) section.selectTab(panel.id);
});
